import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FaqService } from '../shared/services/faq.service';
import { FaQModel } from '../shared/models/faq.model';

@Component({
  selector: 'app-faqpopup',
  templateUrl: './faqpopup.component.html',
  styleUrls: ['./faqpopup.component.css']
})
export class FaqpopupComponent implements OnInit {

  thisData : FaQModel;

  constructor(
    private aroute : ActivatedRoute,
    private service : FaqService) { }

  ngOnInit() {
    this.aroute.queryParams.subscribe(params => {
      let id = params['id'];
      console.log("faqpopup" + id);
      this.getData(id);
    });
  }

  getData(id)
  {
    this.service.getDetail(id).subscribe(
      res => { 
        this.thisData = res as FaQModel;},
      err => {}
    );
    
  } 
}     